import { capitalize, uncapitalize } from '../string';

export const formatMaterials = (materials: string[], otherMaterials?: string | null): string | undefined => {
  let materialsList = [...materials];

  if (otherMaterials) {
    materialsList.push(otherMaterials);
  }

  materialsList = materialsList.map((material, index) => (index === 0 ? capitalize(material) : uncapitalize(material)));

  return materialsList.length ? materialsList.join(', ') : undefined;
};
